import { ChangeEvent, FormEvent, useEffect, useRef, useState } from "react";
import { Alert, Button, Col, Container, Form, Modal, Row, Stack } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import ReactSignatureCanvas from "react-signature-canvas";

import SignatureCanvas from 'react-signature-canvas'
import { DataHandler } from "../dataHandler";
import { FieldDef, LieferscheinPositionModel, Separator } from "../lieferscheinPositionsModel";
import { LieferscheinDataFromDB } from "../liste/lieferscheinData";
import LogoHeader from "../logoHeader/logoHeader";
import ModalAlert from "../sharedComponents/modalAlert";

type LieferscheinState = {
    enabledCheckboxes: { [id: string]: boolean }
}


function Lieferschein() {
    const classNameCheck = 'sm-6';
    const classNameWork = 'xs-3';

    const model = LieferscheinPositionModel.getModel();

    const inputTextRowsXs = "auto";

    const navigate = useNavigate();

    const { id } = useParams();
    let idNumber = -1;
    if (id)
        idNumber = parseInt(id);

    const [state, setState] = useState<LieferscheinState | undefined>();
    const [validated, setValidated] = useState(false);
    const [failed, setFailed] = useState<string | undefined>();
    const [success, setSuccess] = useState<string | undefined>();
    //true is loading
    const [formDataLoadingRunning, setFormDataLoadingRunning] = useState(false);
    const [loadedFormData, setLoadedFormData] = useState<LieferscheinDataFromDB>();
    let techSig: ReactSignatureCanvas | null = null;
    let kundeSig: ReactSignatureCanvas | null = null;


    const updateCheckboxState = (data: LieferscheinDataFromDB) => {
        const lieferscheinState: LieferscheinState = {
            enabledCheckboxes: {}
        };
        for (let k of Object.keys(model)) {
            const category = model[k];
            for (let field of category) {
                const fieldD = field as FieldDef;
                if (fieldD !== null) {

                    const name = fieldD.name;
                    if (data.json[name] === "on")
                        lieferscheinState.enabledCheckboxes[name] = true;
                }
            }
        }
        setState(lieferscheinState);
    }

    useEffect(() => {
        if (idNumber > 0 && formDataLoadingRunning === false) {
            setFormDataLoadingRunning(true); // Loading
            const promise = DataHandler.getLieferschein(idNumber);
            promise.then((data) => {
                setLoadedFormData(data);
                updateCheckboxState(data);
            }).catch((error) => {
                handleDataError(error, "Lieferschein konnte nicht geladen werden.")
            });
        }
    }, []);

    const isDisabled = (id: string): boolean => {
        if (state === undefined)
            return true;
        const checkboxEnabled = state.enabledCheckboxes[id];
        return !checkboxEnabled;
    }

    const checkBoxChecked = (eventArgs: ChangeEvent<HTMLInputElement>) => {
        const id = eventArgs.target.id
        const newState: LieferscheinState = { enabledCheckboxes: {} };
        if (state === undefined) {
            newState.enabledCheckboxes[id] = eventArgs.target.checked;
            setState(newState);
        }
        else {
            newState.enabledCheckboxes = state.enabledCheckboxes;
            newState.enabledCheckboxes[id] = eventArgs.target.checked;
            setState(newState);
        }
    }

    const abbrechen = () => {
        navigate("/");
    }

    const clearForm = () => {
        setFormDataLoadingRunning(false);
        setLoadedFormData(undefined);
        setState(undefined);
    }

    const handleDataError = (error: any, defaultmessage: string) => {
        debugger;
        if (error.message)
            defaultmessage = error.message;
        if (error.response?.data)
            defaultmessage += '\r\n ' + error.response.data;

        setFailed(defaultmessage);
    }

    const submit = (eventArgs: FormEvent) => {
        eventArgs.preventDefault();
        eventArgs.stopPropagation();
        const form = eventArgs.target as HTMLFormElement;
        let valid = form.checkValidity();
        setValidated(true);

        const kundeCanvas = kundeSig?.getTrimmedCanvas();
        /*if ((!kundeCanvas || kundeCanvas?.width < 2 || kundeCanvas?.height < 2) && loadedFormData === undefined) {
            valid = false;
            setFailed("Kundenunterschrift fehlt.")
            return;
        }*/

        const techCanvas = techSig?.getTrimmedCanvas();
        /*if ((!techCanvas || techCanvas?.width < 2 || techCanvas?.height < 2) && loadedFormData === undefined) {
            valid = false;
            setFailed("Technikerunterschrift fehlt.")
            return;
        }*/

        if (valid) {

            const data = new FormData(form);
            const promise1 = new Promise<void>((resolve) => {
                if (techCanvas &&  techCanvas.width > 2 && techCanvas.height > 2) 
                    techCanvas.toBlob((blob: Blob | null) => {
                        if (blob !== null) {
                            data.set('techSig', new File([blob], 'techSig'))
                        }

                        resolve();
                    }, "image/png");
                else
                    resolve();
            });
            const promise2 = new Promise<void>((resolve) => {
                if (kundeCanvas &&  kundeCanvas.width > 2 && kundeCanvas.height > 2)
                    kundeCanvas.toBlob((blob: Blob | null) => {
                        if (blob !== null)
                            data.set('kundeSig', new File([blob], 'kundeSig'))
                        resolve();
                    }, "image/png");
                else
                    resolve();
            })

            const done = (data: any) => {
                if (data.status === 200) {
                    clearForm();
                    navigate("/list")
                    setSuccess("Lieferschein gespeichert");
                }
            };
            const failed = (error: any) => {
                const message = "Fehler beim Speichern des Lieferscheins.";
                handleDataError(error, message);

            };
            promise1.then(() => {
                promise2.then(() => {
                    DataHandler.sendLieferschein(data, done, failed);
                });
            })

        }
        else {
            debugger;
            const firstInvalidElement = form.querySelector(':invalid');
            if (firstInvalidElement)
                firstInvalidElement.scrollIntoView();
        }


    };

    const canvasWidth = 345;

    let formdata: LieferscheinDataFromDB | null;
    if (loadedFormData === undefined)
        formdata = null;
    else
        formdata = loadedFormData;

    return (
        <div className="lieferschein">
            {failed && <ModalAlert callback={()=>setFailed(undefined)} content={failed} contentTitle="Fehler" variant="danger"></ModalAlert>}
            {success && <ModalAlert callback={()=>setSuccess(undefined)} content={success} contentTitle="" variant="info"></ModalAlert>}
            <Container fluid >
                <LogoHeader />
                <Row s>
                    <Col xs="12" sm="5">
                        <Form noValidate validated={validated} onSubmit={submit}>
                            <Row>
                                <Col>
                                    <h1>Lieferschein</h1>
                                </Col>
                                <Col className="align-self-center">
                                    <Form.Select name="type" value={formdata?.json.type}>
                                        <option value="lieferschein">Lieferschein</option>
                                        <option value="schadensbericht">Schadensbericht</option>
                                        <option value="infoblatt">Informationsblatt</option>
                                    </Form.Select>
                                </Col>
                            </Row>

                            <input type={"hidden"} name="id" value={formdata?.id} />
                            <Row xs={inputTextRowsXs}>
                                <h3>Kunde:</h3>
                            </Row>
                            <Row xs={inputTextRowsXs}>
                                <Form.Group>
                                    <Form.Control defaultValue={formdata?.json.kundeName} required type="text" name="kundeName" placeholder="Vorname Nachname"></Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        Name muss angegeben werden.
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Row>
                            <Row xs={inputTextRowsXs}>
                                <Form.Group>
                                    <Form.Control defaultValue={formdata?.json.kundeStrasse} type="text" name="kundeStrasse" placeholder="Straße, HNr./Top"></Form.Control>
                                </Form.Group>
                            </Row>
                            <Row xs={inputTextRowsXs}>
                                <Form.Group>
                                    <Form.Control defaultValue={formdata?.json.kundeOrt} type="text" name="kundeOrt" placeholder="PLZ Ort"></Form.Control>
                                </Form.Group>
                                <Form.Control.Feedback type="invalid">
                                    PLZ, Ort muss angegeben werden.
                                </Form.Control.Feedback>
                            </Row>
                            <Row xs={inputTextRowsXs}>
                                <Form.Group>
                                    <Form.Control defaultValue={formdata?.json.kundeEmail} type="text" name="kundeEmail" placeholder="Email"></Form.Control>
                                </Form.Group>
                            </Row>
                            <hr />
                            <Row xs={inputTextRowsXs}>
                                <h3>Schadensort:</h3>
                            </Row>
                            <Row xs={inputTextRowsXs}>
                                <Form.Group>
                                    <Form.Control defaultValue={formdata?.json.schadenName} required type="text" name="schadenName" placeholder="Vorname Nachname"></Form.Control>
                                </Form.Group>
                            </Row>
                            <Row xs={inputTextRowsXs}>
                                <Form.Group>
                                    <Form.Control defaultValue={formdata?.json.schadenStrasse} required type="text" name="schadenStrasse" placeholder="Straße, HNr./Top"></Form.Control>
                                </Form.Group>
                            </Row>
                            <Row xs={inputTextRowsXs}>
                                <Form.Group>
                                    <Form.Control defaultValue={formdata?.json.schadenOrt} required type="text" name="schadenOrt" placeholder="PLZ Ort"></Form.Control>
                                </Form.Group>
                            </Row>

                            <hr></hr>
                            <Row xs={inputTextRowsXs}>
                                <h3>Auftragsnummer:</h3>
                            </Row>
                            <Row xs={inputTextRowsXs}>
                                <Form.Group>
                                    <Form.Control defaultValue={formdata?.json.auftragsnummer} type="number" name="auftragsnummer" placeholder="Auftragsnummer"></Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        Auftragsnummer muss angegeben werden.
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Row>

                            <hr></hr>
                            <Row xs={inputTextRowsXs}>
                                <h3>Datum:</h3>
                            </Row>
                            <Row xs={inputTextRowsXs}>
                                <Form.Group>
                                    <Form.Control defaultValue={formdata?.json.date || new Date().toISOString().substring(0, 10)} required type="date" name="date"></Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        Datum muss angegeben werden.
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Row>

                            <hr></hr>
                            <Row xs={inputTextRowsXs}>
                                <h3>Beschreibung:</h3>
                            </Row>
                            <Row xs={12}>
                                <Form.Group>
                                    <Form.Control defaultValue={formdata?.json.beschreibung} as="textarea" name="beschreibung"></Form.Control>
                                </Form.Group>
                            </Row>

                            <hr></hr>
                            <Row xs={inputTextRowsXs}>
                                <h3>Techniker:</h3>
                            </Row>
                            <Row xs={inputTextRowsXs}>
                                <Form.Select name="techniker" value={formdata?.json.techniker}>
                                    <option value="simon">Simon Schneider +43 660 2020 003</option>
                                    <option value="matthias">Matthias Heis +43 660 2020 005</option>
                                    <option value="patrick">Patick Enser +43 660 4148534</option>
                                </Form.Select>
                            </Row>
                            <hr />

                            {Object.keys(model).map((key) => {
                                return <div>
                                    <Row>
                                        <Col><h3>{key}</h3></Col>
                                    </Row>
                                    <Stack gap={2}>
                                        {
                                            model[key].map(field => {
                                                if (field instanceof Separator)
                                                    return <hr></hr>
                                                const checkbox = <Form.Group as={Col} className={classNameCheck}>
                                                    <Form.Check id={field.name} checked={state?.enabledCheckboxes[field.name]} onChange={checkBoxChecked} label={field.label} name={field.name} />
                                                </Form.Group>
                                                let arbeitszeit;
                                                if (field.hasArbeitszeit)
                                                    arbeitszeit = <Form.Group as={Col} className={classNameWork}>
                                                        <Form.Control disabled={isDisabled(field.name)} step={0.5} defaultValue={formdata?.json[field.name + 'Zeit']} type='number' placeholder="Arbeitszeit" name={field.name + 'Zeit'}></Form.Control>
                                                    </Form.Group>
                                                return (
                                                    <Row>
                                                        {checkbox}
                                                        {arbeitszeit}
                                                    </Row>
                                                );
                                            })
                                        }
                                    </Stack>
                                    <Row>
                                        <Col><hr></hr></Col>
                                    </Row>
                                </div>
                            })}
                            <Row>
                                <Col>
                                    <div className="signatureContainer">
                                        <SignatureCanvas ref={(ref) => { kundeSig = ref }} penColor="black"
                                            canvasProps={{ width: canvasWidth, height: 130, className: 'sigCanvas' }}
                                        />
                                        <div>
                                            <label >Unterschrift Kunde</label>
                                        </div>
                                    </div>
                                    <div className="signatureContainer">
                                        <Form.Group>
                                            <SignatureCanvas ref={(ref) => { techSig = ref }} penColor="black"
                                                canvasProps={{ width: canvasWidth, height: 130, className: 'sigCanvas' }}
                                            />
                                            <div>
                                                <label >Unterschrift Techniker</label>
                                            </div>
                                        </Form.Group>
                                    </div>
                                </Col>
                            </Row>

                            <hr />
                            <Row>
                                <Col>
                                    <h3>Fotos</h3>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <Form.Group>
                                        <Form.Label>Bild 1</Form.Label>
                                        <Form.Control type="file" name="bild1"></Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <Form.Group>
                                        <Form.Label>Bild 2</Form.Label>
                                        <Form.Control type="file" name="bild2"></Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <Form.Group>
                                        <Form.Label>Bild 3</Form.Label>
                                        <Form.Control type="file" name="bild3"></Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <Form.Group>
                                        <Form.Label>Bild 4</Form.Label>
                                        <Form.Control type="file" name="bild4"></Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <Form.Group>
                                        <Form.Label>Bild 5</Form.Label>
                                        <Form.Control type="file" name="bild5"></Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <Form.Group>
                                        <Form.Label>Bild 6</Form.Label>
                                        <Form.Control type="file" name="bild6"></Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <Form.Group>
                                        <Form.Label>Bild 7</Form.Label>
                                        <Form.Control type="file" name="bild7"></Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <Form.Group>
                                        <Form.Label>Bild 8</Form.Label>
                                        <Form.Control type="file" name="bild8"></Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="gy-5">
                                <Col xs={6} >
                                    <Form.Group>
                                        <div style={{ paddingTop: '1em' }}>
                                            <Button variant="primary" type="submit">Abschließen</Button>
                                        </div>
                                    </Form.Group>
                                </Col>
                                <Col xs={6} >
                                    <div style={{ paddingTop: '1em' }}>
                                        <Button variant="secondary" type="button" onClick={abbrechen}>Abbrechen</Button>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
                <Row>
                    <LogoHeader />
                </Row>
            </Container>
        </div>
    )
}

export default Lieferschein;